import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';

function DescriptionBox({ currentAsset }) {

  const shortText = currentAsset?.desc?.short || '';
  const rawName = currentAsset?.name || '';
  const cleanName = rawName.replace(/\s*-\s*\([\d:]+\s*-\s*[\d:]+\)$/, '').replace(/_/g, ' ');
  const title = currentAsset?.desc?.title || cleanName;

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: {xs: 50, sm: 60, md: 100},
        left: 16,
        zIndex: 30,
        maxWidth: { xs: '50%', sm: '50%', md: '30%' },
        color: 'white',
        pointerEvents: 'auto',
      }}
    >
      <Box
        sx={{
          background: 'rgba(51, 51, 51, 0.3)',
          borderRadius: 2,
          p: 1.2,
          backdropFilter: 'blur(10px)',
        }}
      >
        {title && (
          <Typography
            sx={{
              fontSize: { xs: 15, md: 19, lg: 21 },
              fontWeight: 600,
              mb: 0.5,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
        )}

        {shortText && (
          <Typography
            sx={{
              fontSize: { xs: 13, md: 16, lg: 17 },
              lineHeight: 1.2,
              wordBreak: 'break-word',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {shortText}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default DescriptionBox;
